import React from 'react';
export function TopBar() {
  return <div className="w-full bg-gradient-to-r from-[#FF6B8A] to-[#9B8FE8] text-white text-center py-2 px-4 text-sm font-semibold tracking-wide" data-id="element-118">
      Producto 100% digital · Descarga inmediata · Imprimí sin límites
    </div>;
}